module.exports = __webpack_public_path__ + "img/1x.d29fc9f.jpg";